import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";

import logoLeft from "../../../Assets/Images/logo-left.png";
import logoCenter from "../../../Assets/Images/header-text-center.svg";
import logoLeftMobile from "../../../Assets/Images/mobilelogo.png";
import newLogo from "../../../Assets/Images/new-logo.png";
import bleatLogo from "../../../Assets/Images/bleat-logo.svg";
import assessmentLogo from "../../../Assets/Images/logo-ai-upscaled.png";

import useWindowDimensions from "../../../Hooks/useWindowDimensions";
import AssessmentQuestionContext from "../../../Store/AssessmentQuestionContext";

const Header = (props) => {
  const { windowWidth } = useWindowDimensions();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [resultPage, setResultsPage] = useState(false);
  var currentURL = window.location.href;
  const paths = location.pathname.split("/");
  const currentlyOnAssessmentPage = paths?.includes("assessment");
  const [hasLeader, setHasLeader] = useState(false);
  const [name, setName] = useState("");
  const [isAssessmentLoading, setIsAssessmentLoading] = useState(false);
  const assessCtx = useContext(AssessmentQuestionContext);

  useEffect(() => {
    const loadAssessmentType = () => {
      const hashId = searchParams.get("assessmentId") || paths[2];
      const storedData = hashId
        ? JSON.parse(localStorage.getItem(`searchParams-${hashId}`)) || {}
        : {};
      const hasRequiredDetails = Boolean(
        storedData.userName &&
        storedData.orgId &&
        storedData.clientId &&
        storedData.designation
      );

      if (hashId && !hasRequiredDetails) {
        setIsAssessmentLoading(true);
        setHasLeader(false);
        setName("");
        return;
      }

      setIsAssessmentLoading(false);
      const isSelfAssessment = ["Self-Assessment", "360 Assessment"].includes(storedData.designation);
      const is360Assessment = Boolean(storedData.designation) && !isSelfAssessment;

      if (is360Assessment) {
        setHasLeader(true);
        setName(storedData.leader || "");
        return;
      }

      if (storedData.designation) {
        setHasLeader(false);
        setName("");
        return;
      }

      const leaderName = searchParams.get("leader") || assessCtx.leaderName || "";
      setHasLeader(Boolean(leaderName));
      setName(leaderName);
    };

    loadAssessmentType();
    window.addEventListener("assessment-details-updated", loadAssessmentType);
    return () => window.removeEventListener("assessment-details-updated", loadAssessmentType);
  }, [location.pathname, location.search, searchParams, assessCtx.leaderName]);

  console.log("searchParams", searchParams.get("leader"));

  const formattedName = name
  ? name
      ?.split(' ')
      ?.map(word =>
        word === word.toUpperCase()
          ? word
          : word
              ?.split('-')
              ?.map(
                part =>
                  part?.charAt(0)?.toUpperCase() + part?.slice(1)?.toLowerCase()
              )
              ?.join('-')
      )
      ?.join(' ')
  : '';

  return (
    <>
      <header style={{ backgroundColor: "#ffffff" }}>
        <div className="header-container">
          <div className="header-wrapper">
            <div className="logo-left">
              <img src={newLogo} alt="Logo" className="logo-image" />
            </div>

            <div className="assessment-title">
              <h1>Quadrant Flow</h1>
              {!isAssessmentLoading && <p>{hasLeader ? "360 ASSESSMENT" : "SELF-ASSESSMENT"}</p>}
            </div>

            {hasLeader && !isAssessmentLoading && (
              <div className="logo-right">
                {name && (
                  <p>
                    <span>Observing for</span>
                    <strong>{formattedName}</strong>
                  </p>
                )}
              </div>
            )}

            {!hasLeader && <div className="logo-right"></div>}
          </div>
        </div>
      </header>
      {/* <header
        className={currentlyOnAssessmentPage ? "header-assessment" : "header"}
      >
        <div className="header-wrapper">
          <img
            src={assessmentLogo}
            className={
              windowWidth <= 650
                ? location.pathname.split("/").includes("assessment")
                  ? "logo-center-short"
                  : "logo-center"
                : "logo-center"
            }
            alt="logo"
            height="auto"
            width="auto"
          />
        </div>
      </header> */}
    </>
  );
};

export default Header;
